import { http } from './http';

// Nomenclature Types
export async function getNomenclatureTypes(params) {
    return http.get('wms/nomenclature-types/', { params });
}

export async function createNomenclatureType(data) {
    return http.post('wms/nomenclature-types/', data);
}

export async function updateNomenclatureType(id, data) {
    return http.patch(`wms/nomenclature-types/${id}/`, data);
}

export async function deleteNomenclatureType(id) {
    return http.delete(`wms/nomenclature-types/${id}/`);
}

// Nomenclatures
export async function getNomenclatures(params) {
    return http.get('wms/nomenclatures/', { params });
}

export async function createNomenclature(data) {
    return http.post('wms/nomenclatures/', data);
}

export async function updateNomenclature(id, data) {
    return http.patch(`wms/nomenclatures/${id}/`, data);
}

export async function deleteNomenclature(id) {
    return http.delete(`wms/nomenclatures/${id}/`);
}

// Account Codes (Счета учета) — если эндпоинт недоступен, отдаём справочник по бюджетному кодексу.
const ACCOUNT_CODES_FALLBACK = [
    { id: 1, code: '2360', name: 'Машины и оборудование' },
    { id: 2, code: '2340', name: 'Передаточные устройства' },
    { id: 3, code: '2321', name: 'Нежилые здания' },
    { id: 4, code: '2330', name: 'Сооружения' },
    { id: 5, code: '2370', name: 'Инструменты' },
    { id: 6, code: '1310', name: 'Сырье и материалы' },
    { id: 7, code: '1320', name: 'Готовая продукция' },
    { id: 8, code: '1330', name: 'Товары' },
]
export async function getAccountCodes(params) {
    try {
        return await http.get('wms/account-codes/', { params });
    } catch (e) {
        console.warn('Account codes endpoint not available, using fallback')
        return { data: ACCOUNT_CODES_FALLBACK }
    }
}
